import React from 'react';
import styled from 'styled-components';
import Pic from 'assets/images/completed.png'
import format from "date-fns/format";

const End = ({ message, onTime, status }) => {
  const [endDate, setEndDate] = React.useState(Date())

  console.log(status)

  React.useEffect(() => {
    if (onTime) {
      setEndDate(format(new Date(onTime), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"))
    }
  }, [onTime])

  let CustomMessage = 'We are unable to get information about this survey'
  
  if (status === 3) {
    CustomMessage = 'This survey has been completed'
  }
  if (status > 4 && status < 11) {
    CustomMessage = 'This survey has been closed and is no longer accessible'
  }
  if (status === 100) {
    CustomMessage = 'Hmm! It looks like this survey has expired'
  }

  return (
    <Container>
      <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Image src={Pic} />

        <Title>
          {CustomMessage}
        </Title>
      </div>

      <SubTitle>  {endDate ? `Updated on ${format(
        new Date(endDate.toLocaleString()),
        "EEEE, MMM do h:mm a"
      )}` : ''}

      </SubTitle>

    </Container>

  )
}


export default End

const Title = styled.div`
	font-size: 30px;
  font-weight: bold;
  font-family: 'Red Hat Display', sans-serif;
   line-height:1;
     margin-bottom:10px;

`
const SubTitle = styled.div`
	font-size: 16px;
	line-height: 1.17;
  font-family: 'Red Hat Display', sans-serif;
  margin-bottom:20px;
  text-align:center;

   @media only screen and (min-width:992px){
   margin-bottom:50px;
   font-size: 24px;
  }
`

const Container = styled.div`
  position:absolute;
  top:15%;
  padding:20px;
  width:700px;
  
  @media only screen and (min-width:992px){
    left: 25%;
  top: 15%;
  }

  @media(max-width:768px){
    width:100%;
  }
   
`

const Image = styled.img`
  width:400px;
  margin-bottom:40px;

  @media(max-width:768px){
    width:100%;
  }
`